import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { toast } from '@repo/design-system/components/ui/toaster';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useGetGameMapQuery } from '@repo/store/maps/api/mapsApi';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectCurrentMapInfo, selectExternalMapId, selectIsInCreatorMode } from '@repo/store/maps/slices/mapData';
import { createWemodProtocolUrl } from '@repo/types/maps/map-utils';
import { copyTextToClipboard } from '@repo/utility/clipboard';
export const QuickActions = () => {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const externalMapId = useAppSelector(selectExternalMapId);
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  const mapInfo = useAppSelector(selectCurrentMapInfo);
  const t1 = externalMapId ?? "";
  let t2;
  if ($[1] !== isInCreatorMode || $[2] !== t1) {
    t2 = {
      externalId: t1,
      debug: isInCreatorMode
    };
    $[1] = isInCreatorMode;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !externalMapId;
  let t4;
  if ($[4] !== t3) {
    t4 = {
      skip: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    refetch,
    isFetching
  } = useGetGameMapQuery(t2, t4);
  let t5;
  if ($[6] !== refetch) {
    t5 = () => {
      if (refetch) {
        refetch();
      }
    };
    $[6] = refetch;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleReloadMapData = t5;
  let t6;
  if ($[8] !== mapInfo?.id || $[9] !== mapInfo?.titleId || $[10] !== t) {
    t6 = async () => {
      const protocolUrl = createWemodProtocolUrl({
        titleId: mapInfo?.titleId,
        mapId: mapInfo?.id
      });
      const result = await copyTextToClipboard(protocolUrl);
      if (result.success) {
        toast({
          title: t(_temp),
          variant: "success"
        });
      } else {
        toast({
          title: t(_temp2),
          variant: "error"
        });
      }
    };
    $[8] = mapInfo?.id;
    $[9] = mapInfo?.titleId;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleCopyMapLink = t6;
  let t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = css({
      flex: "1",
      whiteSpace: "nowrap"
    });
    t8 = <Icon icon="refresh" decorative={true} />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isFetching || $[15] !== t) {
    t9 = isFetching ? t(_temp3) : t(_temp4);
    $[14] = isFetching;
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== handleReloadMapData || $[18] !== isFetching || $[19] !== t9) {
    t10 = <Button onClick={handleReloadMapData} color="secondary" size="sm" disabled={isFetching} className={t7}>{t8}{t9}</Button>;
    $[17] = handleReloadMapData;
    $[18] = isFetching;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = css({
      flex: "1",
      whiteSpace: "nowrap"
    });
    t12 = <Icon icon="link" decorative={true} />;
    $[21] = t11;
    $[22] = t12;
  } else {
    t11 = $[21];
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t(_temp5);
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== handleCopyMapLink || $[26] !== t13) {
    t14 = <Button onClick={handleCopyMapLink} color="secondary" size="sm" className={t11}>{t12}{t13}</Button>;
    $[25] = handleCopyMapLink;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14) {
    t15 = <FlexColumn gap="12" width="full"><FlexRow gap="8" wrap="wrap" width="full">{t10}{t14}</FlexRow></FlexColumn>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
function _temp($) {
  return $.map_link_copied_to_clipboard;
}
function _temp2($_0) {
  return $_0.map_link_copy_failed;
}
function _temp3($_1) {
  return $_1.reloading;
}
function _temp4($_2) {
  return $_2.reload_map_data;
}
function _temp5($_3) {
  return $_3.copy_map_link;
}